import { render, staticRenderFns } from "./ProjectPurchaseResultForm.vue?vue&type=template&id=94329106&"
import script from "./ProjectPurchaseResultForm.vue?vue&type=script&lang=js&"
export * from "./ProjectPurchaseResultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports